// Ask the agent about one Notebook cell (Adam, 5 Nov 2026, ask-1771). Opened
// on a chat that has run a data query (/agent/:customer/:sessionId
// ?walkthrough=notebook-ask). The person opens the Notebook (the walkthrough
// guard refuses any label with "book" in it); the walkthrough then types a
// question on the first cell and presses Ask, which only fills the message
// box. It never presses Send, so no agent turn runs.

import type { Walkthrough } from './types'

export const notebookAsk: Walkthrough = {
  slug: 'notebook-ask',
  title: 'Ask the agent about a Notebook cell',
  summary:
    'Opens the Notebook, asks a question on one cell and shows the message it puts in the message box. Nothing is sent.',
  added: '2026-11-05',
  skipE2E: 'starts in a chat that has run a data query, and the fixture job has no such chat',
  steps: [
    {
      route: 'agent-session',
      feature: 'agent/notebook',
      control: 'Notebook',
      say: 'Click Notebook, beside Session options, then Next. The Notebook shows the chat’s tables, charts, composite tables and queries as cells, in the order the chat made them.',
    },
    {
      route: 'agent-session',
      feature: 'agent/notebook',
      control: 'Ask the agent',
      click: 'Ask the agent',
      say: 'Every cell but a note has Ask the agent. It opens a box on that cell for one question about it: a change you want, or something you want to know.',
    },
    {
      route: 'agent-session',
      feature: 'agent/notebook',
      fill: { control: 'Ask the agent about', text: 'Also cut this by region' },
      say: 'Type the question. If you have edited the cell and not sent the edit, the message carries your edit too.',
    },
    {
      route: 'agent-session',
      feature: 'agent/notebook',
      control: 'Ask',
      click: 'Ask',
      say: 'I pressed Ask. The Notebook closed and the message box now starts “About Notebook cell”, naming that cell. You press Send; a walkthrough never does.',
    },
    {
      route: 'agent-session',
      feature: 'agent/notebook',
      say: 'The agent answers in the chat. If its answer is a changed table, chart, composite or query, the Notebook shows it on the same cell with Before and After, and you Confirm or Undo it there. Show in chat on a cell takes you to its card in the conversation.',
    },
  ],
}
